export default "__VITE_ASSET__DAxu6gxs__"